import { Filter } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";

type FilterableAndSortableTableHeadProps = {
  active?: boolean;
  column: string;
  label: string;
  onSort?: (column: string) => void;
  renderSortIcon?: (column: string) => React.ReactNode;
  content: React.ReactNode;
};

export const FilterableAndSortableTableHead = ({
  active = false,
  column,
  label,
  onSort,
  renderSortIcon,
  content,
}: FilterableAndSortableTableHeadProps) => (
  <TableHead className="h-8 cursor-pointer select-none hover:text-foreground/80">
    <div className="flex align-top gap-2 my-2">
      <div className="flex items-center" onClick={() => onSort?.(column)}>
        {label}
        {renderSortIcon?.(column)}
      </div>
      <div className="flex items-center">
        <Popover>
          <PopoverTrigger asChild>
            <Button
              aria-label={label}
              variant="ghost"
              size="icon"
              className={`flex items-center h-2 w-2 p-0 ${active ? "bg-primary/10" : "hover:bg-muted"}`}
            >
              <Filter className={`h-1 w-1 ${active ? "text-primary" : "hover:bg-primary/80"}`} />
            </Button>
          </PopoverTrigger>

          <PopoverContent align="center" side="bottom" className="p-3">
            {content}
          </PopoverContent>
        </Popover>
      </div>
    </div>
  </TableHead>
);
